<!-- 汇率设置 -->
<template>
<!-- <el-form label-width="100px">
    <el-row>
        <el-col :xs="24" :sm="20">
            <el-form-item :label="msg('订单编号')">
                <el-input v-model="code" placeholder="请输入订单编号" size="small"></el-input>
            </el-form-item>
            <el-form-item :label="msg('加单数')">
                <el-input v-model="count" type="number" placeholder="请输入加单数" size="small"></el-input>
            </el-form-item>
        </el-col>
    </el-row>
  
    <div style="text-align:center;">
        <el-button type="primary" size="mini"  @click="onSubmit"><i class="el-icon-check"></i><span>{{msg('确定')}}</span></el-button>
        <el-button  size="mini" v-on:click="$emit('close-dg')">{{msg('取消')}}</el-button>
    </div>
</el-form>  -->
<div style="margin-left:40px;margin-top:-20px;">
    <h3>{{msg('请输入汇率：')}}
    <el-input-number v-model="rate" :precision="2" :step="0.1" :min="0" size="small"></el-input-number>
    </h3>
    <div style="text-align:center; margin-top:40px;">
        <el-button type="primary" size="mini" @click="onSubmit"><i class="el-icon-check"></i><span>{{msg('确定')}}</span></el-button>
        <el-button  size="mini" v-on:click="$emit('close-dg')">{{msg('取消')}}</el-button>
    </div>
</div> 
</template>

<script>
export default {
  name: 'ExpPkgEdit',
  data(){
    return{
        rate:0,
        ids:null,
    }
    
  }, 
  computed:{
  },
  mounted: function(){
  },
  methods:{
    init(ids){
        this.rate = 0;
        this.ids = ids;
    },
    onSubmit(){
        var _this = this;

        if(this.rate == 0){
            this.$message(this.msg('请输入汇率'));
            return;
        }
        this.$axios.post(this.$kit.api.offer.resetRate,{ids:this.ids,rate:this.rate})
            .then((result) =>{
                _this.$message(result.msg);
                if(result.status){
                    _this.$emit("close-dg",true);
                }
            });
    },
  }
}
</script>

<style scoped lang="scss">


</style>
